export default "__VITE_ASSET__BmY22EtF__"